import { render, staticRenderFns } from "./liveDatas.vue?vue&type=template&id=6d20092c&scoped=true"
import script from "./liveDatas.vue?vue&type=script&lang=js"
export * from "./liveDatas.vue?vue&type=script&lang=js"
import style0 from "./liveDatas.vue?vue&type=style&index=0&id=6d20092c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20092c",
  null
  
)

export default component.exports